import { styled, Union2Icon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

const VerticalSpaceBetween = styled(Union2Icon)`
  transform: rotate(90deg);
`;

interface Props {
  justifyContent?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
}

export const JustifySpaceBetween = ({ justifyContent, flexDirection, toggleValues }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-justify"
      id="justify-space-between"
      data-cy="toolbox-flex-justify-space-between"
      onClick={() =>
        toggleValues({
          justifyContent: 'space-between',
        })
      }
      isActive={justifyContent === 'space-between'}
      icon={flexDirection === 'row' ? Union2Icon : VerticalSpaceBetween}
      tooltip="Space between"
      color="light"
    />
  );
};
